import { observable, computed } from 'mobx';
import { Sku } from './Sku';
import { IKeyValue } from './BasicEntities';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface ISizeData {
    key: string;
    value: string;
}

export class Size {
    @observable public key: string = '';
    @observable public value: string = '';
    public parentSku: Sku | null = null;

    constructor(size?: Size) {
        if (size) {
            this.value = size.value;
            this.key = size.key;
            this.parentSku = size.parentSku;
        }
    }

    @computed
    public get smallImage() {
        if (this.parentSku && this.parentSku.smallImages && this.parentSku.smallImages[0]) {
            return this.parentSku.smallImages[0];
        }

        return null;
    }

    public static formattedSizes(sizes: Size[]) {
        const newSize = new Size();
        newSize.value = sizes.map(size => size.value).join(' / ');

        return newSize;
    }

    public toJSON(): ISizeData {
        return {
            key: this.key,
            value: this.value
        };
    }

    public static fromJson(size: IKeyValue): Size {
        const newSize = new Size();
        if (!size) {
            return newSize;
        }
        copyPropertiesExcludeNullsAndGetters(newSize, size);

        return newSize;
    }

    public equals(otherSize: Size): boolean {
        if (this.value !== otherSize.value) {
            return false;
        }

        return true;
    }
}
